<template>
  <div class="modal">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">Tambah Akta Perusahaan</h4>
          <button type="button" class="btn btn-sm" v-on:click="closeModal">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body" v-if="aktaPerusahaanData">
          <div class="horizontal">
            <div class="column5"></div>
            <div class="column100">Bidang</div>
          </div>
          <div class="horizontal" v-for="(item, index) in aktaPerusahaan" :key="index">
            <div class="column5">
              <input class="modal-input-checkbox" type="checkbox" :id="index" :value="item.id"
                v-model="aktaPerusahaan[index]['checked']" />
            </div>
            <div class="column100">{{ item.desc }}</div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" v-on:click="closeModal()">
            Selesai
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      aktaPerusahaan: [],
    }
  },
  computed: {
    // aktaPerusahaanData: async function() {
    //   let getLegal = await this.$getLegal()

    //   getLegal = await getLegal.filter(i => i.type == 1)
    //   const defaultAktaPerusahaan = await this.$store.state.landingpage
    //     .addedAktaPerusahaan

    //   let reduceAktaPerusahaan = await getLegal.reduce(
    //     (a, b) => ({ ...a, [b.id]: b }),
    //     {}
    //   )
    //   let reduceDefault =
    //     (await defaultAktaPerusahaan) &&
    //     defaultAktaPerusahaan.reduce((a, b) => ({ ...a, [b.id]: b }), {})

    //   let combine = { ...reduceAktaPerusahaan, ...reduceDefault }

    //   let newAktaPerusahaan = await Object.values(combine)
    //   this.aktaPerusahaan = newAktaPerusahaan.sort((a, b) =>
    //     this.$sortAsc(a, b)
    //   )
    // },

    aktaPerusahaanData: async function() {
      let getLegal = await this.$getLegal();
      getLegal = await getLegal.filter(i => i.type == 1);

      const defaultAktaPerusahaan = await this.$store.state.landingpage
        .addedAktaPerusahaan

      let reduceAktaPerusahaan = await getLegal.reduce(
        (a, b) => ({ ...a, [b.id]: b }),
        {}
      )
      let reduceDefault =
        (await defaultAktaPerusahaan) &&
        defaultAktaPerusahaan.reduce((a, b) => ({ ...a, [b.id]: b }), {});

      let combine = { ...reduceAktaPerusahaan, ...reduceDefault };

      let newAktaPerusahaan = await Object.values(combine);

      const selectedIds = [1, 2, 3, 4];
        newAktaPerusahaan = newAktaPerusahaan.map((item) => {
          if (selectedIds.includes(item.id)) {
            return { ...item, checked: true };
          }
          return item;
        });
      this.aktaPerusahaan = newAktaPerusahaan.sort((a, b) => this.$sortAsc(a, b));
    },
  },
  methods: {
    async closeModal() {
      const filterAktaPerusahaan = this.aktaPerusahaan
      //   (await this.aktaPerusahaan) &&
      //   this.aktaPerusahaan.filter(i => i.checked && i.checked == true)

      await this.$store.commit('landingpage/SET_LANDINGPAGE_MODAL', {
        name: 'addAktaPerusahaan',
        status: false,
      })
      await this.$store.commit('landingpage/SET_CHECKED', {
        name: 'addedAktaPerusahaan',
        filter: filterAktaPerusahaan,
      })
    },
  },
}
</script>
<style scoped>
.modal {
  width: 100vw;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1050;
  display: block;
  overflow: hidden;
  outline: 0;
  background-color: rgba(0, 0, 0, 0.6);
}

.modal-dialog {
  width: 100vw;
  background-color: green;
}

.modal-content {
  width: 90vw;
  position: absolute;
  transform: translateX(-30%);
}

.modal-body {
  height: 50vh;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
}

.modal-input-checkbox {
  margin-right: 20px;
}
</style>
